import { useRouteConfig } from '@hook/route/use-route-config.hook';

export const useInit = () => useRouteConfig();
